import { useProductViewCommon } from '@/hooks/useProductViewCommon';
import { useProductViewDataSource } from '@/hooks/useProductViewDataSource';
import { ProductViewHook } from '@/types/product-view-model';
import { ProductViewModes } from '@/utils/productStateUtils';

/**
 * Hook used by merchandise product routes.
 *
 * Merchandise shares the same loading/saving behavior as products. Its template
 * decides which merchandising-specific tables, tabs, and edit modal to render.
 */
export function useMerchProductView(
  productViewMode: ProductViewModes
): ProductViewHook {
  const dataSource = useProductViewDataSource(productViewMode);
  return useProductViewCommon(dataSource);
}
